/**
 * Linear transformation that maps [0, 1] to [a, b]
 */

export function fromUnitInterval(a: number, b: number): (x: number) => number {
  return (x) => (b - a) * x + a;
}
